import { makeStyles } from '@mui/styles';

export const stickyWidths = ['150px', '200px', '250px', '100px', '150px', '200px'];

export const flightAndAncillaryIssueSummaryListStyles = makeStyles(() => ({
	backdrop: {
		zIndex: 1301,
		color: '#fff',
	},
	tableContainer: {
		maxHeight: 'calc(100vh - 300px)',
		overflowX: 'auto',
		position: 'relative',
	},
	cellNoWrap: {
		whiteSpace: 'nowrap',
		backgroundColor: 'white',
		position: 'relative',
		zIndex: 1,
	},
	hoverRow: {
		'&:hover': {
			backgroundColor: '#f5f5f5 !important',
			cursor: 'pointer',
		},
	},
	clickableCell: {
		'&:hover': {
			textDecoration: 'underline',
			color: '#1976d2',
		},
		cursor: 'pointer',
	},
	containerButtons: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
	},
	sticky1: {
		position: 'sticky',
		left: 0,
		zIndex: 2,
		backgroundColor: 'white',
		minWidth: stickyWidths[0],
		maxWidth: stickyWidths[0],
		'&::before': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: -1,
			bottom: 0,
			width: '1px',
			backgroundColor: '#e0e0e0',
		},
	},
	sticky2: {
		position: 'sticky',
		left: stickyWidths[0],
		zIndex: 2,
		backgroundColor: 'white',
		minWidth: stickyWidths[1],
		maxWidth: stickyWidths[1],
		'&::before': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: -1,
			bottom: 0,
			width: '1px',
			backgroundColor: '#e0e0e0',
		},
	},
	sticky3: {
		position: 'sticky',
		left: `calc(${stickyWidths[0]} + ${stickyWidths[1]})`,
		zIndex: 2,
		backgroundColor: 'white',
		minWidth: stickyWidths[2],
		maxWidth: stickyWidths[2],
		'&::before': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: -1,
			bottom: 0,
			width: '1px',
			backgroundColor: '#e0e0e0',
		},
	},
	sticky4: {
		position: 'sticky',
		left: `calc(${stickyWidths[0]} + ${stickyWidths[1]} + ${stickyWidths[2]})`,
		zIndex: 2,
		backgroundColor: 'white',
		minWidth: stickyWidths[3],
		maxWidth: stickyWidths[3],
		'&::before': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: -1,
			bottom: 0,
			width: '1px',
			backgroundColor: '#e0e0e0',
		},
	},
	sticky5: {
		position: 'sticky',
		left: `calc(${stickyWidths[0]} + ${stickyWidths[1]} + ${stickyWidths[2]} + ${stickyWidths[3]})`,
		zIndex: 2,
		backgroundColor: 'white',
		minWidth: stickyWidths[4],
		maxWidth: stickyWidths[4],
		'&::before': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: -1,
			bottom: 0,
			width: '1px',
			backgroundColor: '#e0e0e0',
		},
	},
	sticky6: {
		position: 'sticky',
		left: `calc(${stickyWidths[0]} + ${stickyWidths[1]} + ${stickyWidths[2]} + ${stickyWidths[3]} + ${stickyWidths[4]})`,
		zIndex: 2,
		backgroundColor: 'white',
		minWidth: stickyWidths[5],
		maxWidth: stickyWidths[5],
		'&::before': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: -1,
			bottom: 0,
			width: '1px',
			backgroundColor: '#e0e0e0',
		},
	},
}));
